module.exports = __webpack_public_path__ + "static/media/home-logo.39b18728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-logo.png
// module id = 729
// module chunks = 1